module.exports = __webpack_public_path__ + "img/OM.288b67ad.png";